/**
 * flatpickr replacement for bootstrap-datepicker (`.datepicker`, yyyy-mm-dd)
 * and tempus-dominus (`.datetimepicker`, YYYY-MM-DD HH:mm).
 */
import flatpickr from 'flatpickr';
import dayjs from 'dayjs';

const DATE = { dateFormat: 'Y-m-d', allowInput: true, disableMobile: true, position: 'below' };
const DATETIME = { dateFormat: 'Y-m-d H:i', enableTime: true, time_24hr: true, allowInput: true, disableMobile: true, position: 'below' };

// With allowInput, flatpickr ignores Escape typed in the input; the old pickers closed on it.
function closeOnEscape(el) {
    el.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && el._flatpickr?.isOpen) el._flatpickr.close();
    });
}

export function attachDatePicker(el, options = {}) {
    if (el._flatpickr) return el._flatpickr;
    el.setAttribute('autocomplete', 'off');
    closeOnEscape(el);
    return flatpickr(el, { ...DATE, ...options });
}

export function attachDateTimePicker(el, options = {}) {
    if (el._flatpickr) return el._flatpickr;
    el.setAttribute('autocomplete', 'off');
    closeOnEscape(el);
    return flatpickr(el, { ...DATETIME, ...options });
}

export function initDatePickers(root = document) {
    root.querySelectorAll('input.datepicker').forEach((el) => attachDatePicker(el));
    root.querySelectorAll('input.datetimepicker').forEach((el) => attachDateTimePicker(el));
}

/** Old datepicker.js helpers, now backed by dayjs instead of moment (same format tokens). */
export function date_format(dateInput, format) {
    if (format == null || format === '') format = 'YYYY-MM-DD';
    return dayjs(new Date(dateInput)).format(format);
}

export function datetime_format(dateInput) {
    return dayjs(new Date(dateInput)).format('YYYY-MM-DD HH:mm:ss');
}
